import { render } from "./YesterdayBlock.vue?vue&type=template&id=1efd0f32"
import script from "./YesterdayBlock.vue?vue&type=script&lang=js"
export * from "./YesterdayBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__